export default {
  enums: [
    { id: 'SELF_MADE' },
    { id: 'OPERATOR' },
  ]
};